import { centroid, multiPoint } from '@turf/turf';

export class Region {
    private points: { lat: number; lng: number }[] = [];
    private length: number;

    constructor(points: { lat: number; lng: number }[] | { latitude: number; longitude: number }[]) {
        this.points = (points ?? [])
            .map(p => {
                return {
                    lat: +(p.lat ?? p.latitude),
                    lng: +(p.lng ?? p.longitude),
                };
            })
            // Turf throws on anything that is not a number, so drop incomplete points here.
            .filter(p => isFinite(p.lat) && isFinite(p.lng));
        this.length = this.points.length;
    }

    public area() {
        let area = 0,
            i,
            j,
            point1,
            point2;

        for (i = 0, j = this.length - 1; i < this.length; j = i, i++) {
            point1 = this.points[i];
            point2 = this.points[j];
            area += point1.lng * point2.lat;
            area -= point1.lat * point2.lng;
        }
        area /= 2;

        return area;
    }

    public hasPoints() {
        return this.points.length > 0;
    }

    public centroid() {
        if (!this.points.length) {
            return null;
        }
        const center = centroid(multiPoint(this.points.map(p => [p.lng, p.lat])));
        return {
            lat: center.geometry.coordinates[1],
            lng: center.geometry.coordinates[0],
        };
    }

    public bestMapView(mapWidth, mapHeight, buffer) {
        const zoomLevel = 0;
        let maxLat = -85;
        let minLat = 85;
        let maxLon = -180;
        let minLon = 180;

        this.points.forEach(point => {
            if (point.lat > maxLat) {
                maxLat = point.lat;
            }

            if (point.lat < minLat) {
                minLat = point.lat;
            }

            if (point.lng > maxLon) {
                maxLon = point.lng;
            }

            if (point.lng < minLon) {
                minLon = point.lng;
            }
        });

        let zoom1 = 0;
        let zoom2 = 0;

        //Determine the best zoom level based on the map scale and bounding coordinate information
        if (maxLon != minLon && maxLat != minLat) {
            //best zoom level based on map width
            zoom1 = Math.log(((360.0 / 256.0) * (mapWidth - 2 * buffer)) / (maxLon - minLon)) / Math.log(2);
            //best zoom level based on map height
            zoom2 = Math.log(((180.0 / 256.0) * (mapHeight - 2 * buffer)) / (maxLat - minLat)) / Math.log(2);
        }

        return Math.floor(zoom1 < zoom2 ? zoom1 : zoom2);
    }

    public insideCustomer(center) {
        let isInside = false;
        let j = 0;
        const x = center.lng;
        const y = center.lat;

        const paths = this.points;

        for (let i = 0; i < paths.length; i++) {
            j++;
            if (j == paths.length) {
                j = 0;
            }
            if ((paths[i].lat < y && paths[j].lat >= y) || (paths[j].lat < y && paths[i].lat >= y)) {
                if (
                    paths[i].lng +
                        ((y - paths[i].lat) / (paths[j].lat - paths[i].lat)) * (paths[j].lng - paths[i].lng) <
                    x
                ) {
                    isInside = !isInside;
                }
            }
        }

        return isInside;
    }
}
